import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticsService } from '../../../services/analytics.service';
import { environment } from '../../../../environments/environment';
import { select, Store } from '@ngrx/store';
import { AffinityPartnerFlags } from '../../../model/affinity-partner';
import { isEmpty, isNil } from 'lodash-es';

@Component({
    standalone: false,
    selector: 'app-home-banner',
    templateUrl: './home-banner.component.html',
    styleUrls: ['./home-banner.component.scss'],
})
export class HomeBannerComponent implements OnInit {
    blobURL = environment.blobStorageBaseURL;
    affinityPartnerFlags: AffinityPartnerFlags;
    @Input() bannerContent: any;

    constructor(
        private router: Router,
        private _analytics: AnalyticsService,
        private _store: Store<{
            AffinityPartnerFlags: AffinityPartnerFlags;
        }>
    ) {
        this._store
            .pipe(select('AffinityPartnerFlags'))
            .subscribe((AffinityPartnerFlags) => {
                if (AffinityPartnerFlags && AffinityPartnerFlags.partnercode) {
                    if (
                        AffinityPartnerFlags.partnercode &&
                        !isNil(AffinityPartnerFlags.partnercode) &&
                        !isEmpty(AffinityPartnerFlags.partnercode)
                    ) {
                        this.affinityPartnerFlags = AffinityPartnerFlags;
                        if (
                            this.affinityPartnerFlags.partnercode ===
                                'sentinelone' ||
                            this.affinityPartnerFlags.partnercode ===
                                'callis' ||
                            this.affinityPartnerFlags.partnercode === 'FCCS' ||
                            this.affinityPartnerFlags.partnercode === 'sentara'
                        ) {
                            var styleElem = document.head.appendChild(
                                document.createElement('style')
                            );
                            styleElem.innerHTML =
                                '.getQuote_color {background-color: transparent !important;}';
                        }
                        if (
                            this.affinityPartnerFlags.partnercode === 'jove' ||
                            this.affinityPartnerFlags.partnercode === 'ISBA10'
                        ) {
                            var styleElem = document.head.appendChild(
                                document.createElement('style')
                            );
                            styleElem.innerHTML =
                                '.getQuote_color {background-color: transparent !important;}';
                        }
                    }
                }
            });
    }

    ngOnInit(): void {
        if (
            this.affinityPartnerFlags &&
            this.affinityPartnerFlags.partnercode &&
            !isNil(this.affinityPartnerFlags.partnercode) &&
            !isEmpty(this.affinityPartnerFlags.partnercode) &&
            (this.affinityPartnerFlags.partnercode === 'sentinelone' ||
                this.affinityPartnerFlags.partnercode === 'callis' ||
                this.affinityPartnerFlags.partnercode === 'FCCS' ||
                this.affinityPartnerFlags.partnercode === 'sentara' ||
                this.affinityPartnerFlags.partnercode.toLowerCase() ===
                    'zion' ||
                this.affinityPartnerFlags.partnercode.toLowerCase() ===
                    'tlie') &&
            this.bannerContent &&
            this.bannerContent.navigation &&
            this.bannerContent.navigation.length > 0
        ) {
            this.bannerContent.navigation.forEach((btn) => {
                if (btn && btn.id && btn.id === 'getQuote') {
                    btn.text = 'Get a Cyber Quote';
                }
            });
        }
    }

    navigateTo(action) {
        this._analytics.eventTrack.next({
            category: 'HomePage',
            action: 'BUTTON_CLICK',
            label: `${action.text}`,
        });
        if (
            this.affinityPartnerFlags &&
            this.affinityPartnerFlags.partnerProducerCd &&
            !isNil(this.affinityPartnerFlags.partnerProducerCd) &&
            !isEmpty(this.affinityPartnerFlags.partnerProducerCd)
        ) {
            this.router.navigate([action.url], {
                queryParams: {
                    producerCd: this.affinityPartnerFlags.partnerProducerCd,
                },
            });
        } else {
            this.router.navigate([action.url]);
        }
    }
}
